module.exports = __webpack_public_path__ + "static/handoff@2x-bea4a77746924d84f022072d4c37cd01.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/sketch/handoff@2x.png
// module id = 449
// module chunks = 131293461488081 145262073310797 281043220932899